import { faSave } from "@fortawesome/pro-solid-svg-icons"
import { useContext } from "react"
import { hasValue } from "../../helpers/nullable"
import HeroButton from "../common/HeroButton"
import HeroButtonsContainer from "../common/HeroButtonsContainer"
import HeroContainer from "../common/HeroContainer"
import UserForm from "./UserForm"
import { UserDto } from "./usersApi"
import { areUserRequiredFieldsEmpty, shouldSaveButtonBeDisabled } from "./usersModel"
import UsersPageContext from "./UsersPageContext"
import { useDeleteUserMutation, useRestoreUserMutation, useUpdateUserMutation } from "./usersQueries"

type Props = {
  heroImage: string
  onUserDeletionChange: () => void
}

const EditUserView = ({ heroImage, onUserDeletionChange }: Props) => {
  const { state, dispatch, isEmailAvailable, isDeletedUser, userHasChanges, isEmailValid, isNewUser } = useContext(UsersPageContext)

  const updateUserMutation = useUpdateUserMutation(
    state.email, 
    (updatedUser) => {
      dispatch({ type: 'RESET_FORM', payload: updatedUser })
    })
  const deleteUserMutation = useDeleteUserMutation()
  const restoreUserMutation = useRestoreUserMutation()

  const userName = state.displayName.length > 0 
    ? state.displayName 
    : 'New User'

  const updateUser = () => {
    const userData: UserDto = {
      ...state, 
      avatarDataBase64: state.avatarDataBase64 || null
    }

    if (hasValue(state)) {
      updateUserMutation.mutate(userData)
    }
  };

  const deleteUser = () => {
    if (hasValue(state.email)) {
      deleteUserMutation.mutate(state.email)
      onUserDeletionChange()
    }
  }

  const restoreUser = () => {
    if (hasValue(state.email)) {
      restoreUserMutation.mutate(state.email)
      onUserDeletionChange()
    }
  }

  return <div>
    <HeroContainer imgSrc={heroImage} />
    <div className="hero-details">
      <h1>{userName}</h1>
      {isDeletedUser && <h1 className="hero-details-deleted-item">
        <span>
          <span className="margin-30">DELETED</span>
          <br />
          <small className="display-none-tiny">(scroll to bottom and click on "Restore" to un-delete it)</small>
        </span>
      </h1>}
      {!isDeletedUser && <HeroButtonsContainer>
        <HeroButton 
          icon={faSave} 
          onClick={updateUser} 
          disabled={
            isNewUser 
              ? areUserRequiredFieldsEmpty(state) || !isEmailValid || !isEmailAvailable || updateUserMutation.isLoading
              : shouldSaveButtonBeDisabled(userHasChanges!, state, isEmailValid, isNewUser, isEmailAvailable)
          } 
        />
      </HeroButtonsContainer>}
    </div>
    <section>
      <UserForm
        onDelete={deleteUser}
        onRestore={restoreUser}
      />
    </section>
  </div>
}

export default EditUserView